export const IT = {
  "Open document": "Apri documento",
  "Upload file": "Caricare un file",
  "Drop file here to upload": "Trascina qui il file da caricare",
  "Disc": "Disco",
  "URL": "URL",
  "FILE": "FILE",
  "SIZE": "DIMENSIONE",
  "MB": "MB",
  "KB": "KB",
  "Bytes": "Byte",
  "Loading... Please wait.": "Attendere il caricamento prego.",
  "Fit Width": "Larghezza adatta",
  "Fit Height": "Altezza giusta",
  "Password protected document": "Documento protetto da password",
  "Password": "Parola d'ordine",
  "Open": "Aprire",
  "Password Required": "Password richiesta",
  "Incorrect password": "password errata",
  "Error": "Errore",
  "Something went wrong": "Qualcosa Ã¨ andato storto",
  "Server is not available": "Il server non Ã¨ disponibile",
  "of": "di",
  "Please wait...": "Attendere prego..."
};
